'use client'

import { useEffect, useState } from 'react'

import { remainingUntil } from '../lib/formatCountdown'

/**
 * Milissegundos restantes até o fim da janela, atualizados a cada segundo.
 * Zerando, dispara `onElapsed` uma única vez — é o gatilho para reconsultar o
 * estado em vez de esperar o refetch periódico.
 */
export function useMaintenanceCountdown(
  endsAt: string | null,
  onElapsed?: () => void
) {
  const [remainingMs, setRemainingMs] = useState(() =>
    remainingUntil(endsAt, Date.now())
  )

  useEffect(() => {
    setRemainingMs(remainingUntil(endsAt, Date.now()))

    if (!endsAt) return

    let elapsedFired = false

    const id = window.setInterval(() => {
      const next = remainingUntil(endsAt, Date.now())
      setRemainingMs(next)

      if (next === 0 && !elapsedFired) {
        elapsedFired = true
        onElapsed?.()
      }
    }, 1000)

    return () => window.clearInterval(id)
  }, [endsAt, onElapsed])

  return remainingMs
}
